import Vue    from 'vue'
import App    from './App.vue'
import router from './router'
import store  from './store'
import '@/assets/css/common.scss'
import 'amfe-flexible'  // rem设置
Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$axios = axios

import MobileMessage from 'vue-mobile-message'  // 消息提示框
Vue.use(MobileMessage, {
  htmlSupport: true
})

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import PreventOverscroll from 'vue-prevent-overscroll.js';
Vue.use(PreventOverscroll); // 滚动穿透

import components from '@/components' // 组件
for (let k in components) {   // 注册所有组件
  Vue.component(k, components[k])
}

import EbLoading from '@/components/loading'
Vue.use(EbLoading)

import directives from '@/directives' // 指令
directives.map(item => {  // 注册所有指令
  for (let k in item) {
    Vue.directive(k, item[k])
  }
})

import { Plugin } from 'vue-fragment' // 代替template解决方案，不渲染元素
Vue.use(Plugin)

// 全局注册fetch方法
import fetch from '@/utils/fetch'
Vue.prototype.$fetch = fetch

import Log from '@/utils/log'

// 设置日志唯一log
Log.getInstance().setUuid()

Vue.prototype.$log = Log.getInstance()


// 全局注册方法
import Prototype from '@/utils/global-func'
Vue.use(Prototype)

var rem = require('./utils/rem')
rem({})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
